document.addEventListener('rebuy.loaded', (event) => {

  console.log('rebuy.loaded');
  //const smartCart = Rebuy.SmartCart;
  const subtotalMax = 250000;
  const subtotalMinSig = 150000;
  const totalLimitMsg = "There is a maximum of $2,500 per order. Please remove some items from your cart.";
  const totalLimitSigMsg = "Please note that we require a signature upon delivery for orders over $1,500.";

  let checkoutBtn = null;
  let cartInfoMsg = null;

  const bundleSku = 'F052-01-BND0';

  const updateCheckoutBtn = (cart) => {

    findCheckoutBtn();

    if(checkoutBtn != null){
      if(cart.total_price >= subtotalMax){
        cartInfoMsg.innerHTML = totalLimitMsg;
        checkoutBtn.style.display = "none";
      }else if(cart.total_price >= subtotalMinSig){
        checkoutBtn.style.display = "flex";
        cartInfoMsg.innerHTML = totalLimitSigMsg;
      }else{
        cartInfoMsg.innerHTML = "";
        checkoutBtn.style.display = "flex";
      }
    }
  }

  const findCheckoutBtn = () => {
    checkoutBtn = document.querySelector('[data-rebuy-component="checkout-area"]');
    cartInfoMsg = document.querySelector('.cart-info-msg');
  }

  const updateDeliveryInstructions = (smartcart) => 
    {
      const cartItems = smartcart.cart.items;

      let formatedMessage = '';
      let bundleInfo = '';
      //console.log(noteParts);

      if(cartItems.length)
      {
        let bundleProducts = _.where(cartItems, {sku: bundleSku});
        if(bundleProducts.length >= 1)
        {
          //product_title
          bundleInfo += "Custom Sets\n";
          _.each(bundleProducts, function(item)
          {
            bundleInfo += item.product_title+" "+bundleSku+ ":\n";
            _.each(item.properties, function(prop)
            {
              let propParts = prop.split('[');
              bundleInfo += '['+propParts[1]+ ",";;
            });
            bundleInfo += "\n";
          });
        }else{
          bundleInfo = '';
        }
      }

      let completeNotes = bundleInfo+formatedMessage;
      //console.log(completeNotes);
      if(smartcart.cart.note != completeNotes){
         smartcart.cart.note = completeNotes;
        //console.log("notes updated!");
      }
  };

  document.addEventListener('rebuy:cart.change', (event) => { 
    //console.log('rebuy:cart.change event');
    //need to delay because smart cart progress bar updates before this event fires.
    
    setTimeout(() => {
        updateCheckoutBtn(event.detail.cart.cart);  
      }, 10);
    

    //limitItemQuantities();
    
  });


  document.addEventListener('rebuy:smartcart.show', (event) => {
    console.log('rebuy:smartcart.show: smartcart');
    //console.log(event.detail.smartcart);
    updateCheckoutBtn(event.detail.smartcart.cart);

    updateDeliveryInstructions(event.detail.smartcart);
    
  });
   
});
